function getDomains(): { secondLevelDomain: string | null; thirdLevelDomain: string | null } {
  const hostname = window.location.hostname
  const parts = hostname.split('.')
  const secondLevelDomain = parts.length >= 2 ? parts[parts.length - 2] : null
  const thirdLevelDomain = parts.length >= 3 ? parts[parts.length - 3] : null
  return { secondLevelDomain, thirdLevelDomain }
}
export default getDomains
